import { SegmentedControl } from "@mantine/core";

type Props = {
  tab: string,
  setTab: any,
};

const InboxTabs = ({ tab, setTab }: Props) => (
  <SegmentedControl
    value={tab}
    w={200}
    onChange={(value: any) => {
      setTab(value);
    }}
    data={[
      { label: "Accounts", value: "accounts" },
      { label: "Users", value: "users" },
    ]}
  />
);

export default InboxTabs;
